import { createApp } from 'vue';

import App from './App';
import router from './router';
// import store from './store';

import { createPinia } from 'pinia';

import titleMixin from '@/utils/titleMixin';
// import { createHead } from "@vueuse/head";

import PrimeVue from 'primevue/config';
import Lara from '@primevue/themes/aura';


const pinia = createPinia()

const ap = createApp(App)

// ap.use(store)
ap.use(pinia);
ap.use(router);
ap.use(PrimeVue, {
    // unstyled: true,
    theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            // darkModeSelector: 'dark',
            darkModeSelector: false,
            cssLayer: true
        }
    },
    // semantic:{
    //     primary: {
    //         color: '#640000',
    //         background: '#640000',
    //     },
    //     colorScheme: {
    //         light: {
    //             primary: {
    //                 color: '#640000',
    //                 background: '#640000',
    //             }
    //         },
    //         // dark: {
    //         //     primary: {
    //         //         color: 'rgb(100,0,0)',
    //         //     },
    //         // },
    //     },
    // },
    // handle: {
    //     // borderRadius: '0px'
    // },
 });

// ap.use(createHead())

ap.mixin(titleMixin);


ap.config.globalProperties.$filters = {
    formatDate: value => {
        if( value ){
            let d = value.split('-');
            // let m = new Date(0,d[1],0).toLocaleDateString(store.state.lang, {month: 'short'});
            return `${d[2]}.${d[1]}.${d[0]}`;
        }
        else return value;
        // new Date(value).toLocaleDateString(store.state.lang, {
        //     year: 'numeric',
        //     month: 'short',
        //     day: 'numeric'
        // }),
    },

    replace: (str, txt1, txt2) => {
        let re = RegExp(txt1, "mgi");
        return str.replace(re, txt2);
    },

    capitalize: str => str != '' ? (str.charAt(0).toUpperCase() + str.slice(1)) : '',

    stripTags: str => str != '' ? str.replace(/(<[^>]*>)*/gm, '') : '',

    formatCurrency: (value) => {
        if (value)
            return value.toLocaleString("az-AZ", {
                style: "currency",
                currency: "AZN",
            });
        return value;
    },
};


// ap.config.errorHandler = (err, instance, info) => {
//     return false;
//     // handle error, e.g. report to a service
// }

ap.mount('#app');
